/**
 * Greeting helpers.
 *
 * Names in ClientOps are entered "Lastname, Firstname" (surname first, comma-
 * separated). The user-facing greeting should use the part AFTER the comma
 * (the first name). If no comma is present, we fall back to the first
 * whitespace-separated token.
 *
 * For company entities, the greeting addresses "The Director" followed by
 * the company name (there is no individual first name to use).
 */

/** Return the first-name portion of a "Lastname, Firstname" string. */
export function firstNameFromLastFirst(raw) {
    const s = (raw || "").trim();
    if (!s) return "";
    if (s.includes(",")) {
        const afterComma = s.split(",").slice(1).join(",").trim();
        if (afterComma) return afterComma.split(/\s+/)[0];
    }
    return s.split(/\s+/)[0];
}

/**
 * Build the greeting subject for a portal user.
 *   - Company client → "The Director, Acme Ltd"
 *   - Otherwise      → first name parsed from "Lastname, Firstname"
 *
 * `fallback` is used when neither a person nor a company name is available.
 */
export function portalGreetingName(user, activeClient, fallback = "there") {
    const entity = (activeClient?.entity_type || "").toLowerCase();
    if (entity === "company" && activeClient?.name) {
        return `The Director, ${activeClient.name}`;
    }
    return (
        firstNameFromLastFirst(user?.name) ||
        firstNameFromLastFirst(activeClient?.name) ||
        fallback
    );
}
